import { Business } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { FIELD_ABR_BASE_PATH } from '../constants/fieldBasePath';

export const getBusinessByAbnOrAcn = async (
  constructGet: ConstructGet,
  value: string,
): Promise<NonPaginatedResponse<Business> | undefined> =>
  constructGet<NonPaginatedResponse<Business>>(
    `${FIELD_ABR_BASE_PATH}/lookup`,
    { params: { value } },
  );
